enum PavementImageType {
  Image3D = "Image3D",
  ImageRange = "ImageRange",
}

export default PavementImageType;
